<template>
  <div class="m-card-text">
    <slot />
  </div>
</template>

<style scoped>
.m-card-text {
  padding: var(--m-space-4);
}
</style>
